/**
 * licenses is a list of licenses that are available in the application.
 */
export type License = {
  id: string;
  href: string;
  title: string;
  icon: {
    style: string;
    name: string;
  };
  matchesFeatures: string[];
  matchesPermissions: string[];
};
export const licenses: License[] = [
  {
    id: "dealer-intake",
    href: "/dealer-intake",
    title: "Dealer Intake",
    icon: {
      style: "fad",
      name: "car-building",
    },
    matchesFeatures: ["dealer_intake"],
    matchesPermissions: ["admin_repair_direct_generic_dossier_create"],
  },
  {
    id: "dashboard",
    href: "/dashboard",
    title: "Dashboard",
    icon: {
      style: "fad",
      name: "list-check",
    },
    matchesFeatures: ["rumble_direct_dashboard"],
    matchesPermissions: ["admin_dossier_read"],
  },
];
